(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBestSellers(root) {
    if (!root || root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    var track = root.querySelector('.hs-bs__track');
    var viewport = root.querySelector('.hs-bs__viewport');
    var prev = root.querySelector('.hs-bs__prev');
    var next = root.querySelector('.hs-bs__next');

    if (!track || !viewport || !prev || !next) {
      return;
    }

    var fallback = root.dataset.fallback === 'true';

    var cards = Array.prototype.slice.call(
      root.querySelectorAll('.hs-bs__card')
    );

    var index = 0;
    var startX = 0;
    var dragging = false;

    if (fallback && cards.length > 10) {
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));

        var temp = cards[i];

        cards[i] = cards[j];
        cards[j] = temp;
      }

      cards.forEach(function (card) {
        track.appendChild(card);
      });

      cards.slice(10).forEach(function (card) {
        card.remove();
      });

      cards = Array.prototype.slice.call(
        root.querySelectorAll('.hs-bs__card')
      );
    }

    function visibleCount() {
      if (window.innerWidth <= 760) {
        return 2;
      }

      if (window.innerWidth <= 1100) {
        return 3;
      }

      return 4;
    }

    function update() {
      if (!cards.length) {
        return;
      }

      var visible = visibleCount();

      var max = Math.max(
        0,
        cards.length - visible
      );

      index = Math.max(
        0,
        Math.min(index, max)
      );

      var width = cards[0].getBoundingClientRect().width;
      var gap =
        parseFloat(
          window.getComputedStyle(track).gap
        ) || 0;

      track.style.transform =
        'translate3d(-' +
        (index * (width + gap)) +
        'px, 0, 0)';

      prev.disabled = index <= 0;
      next.disabled = index >= max;
    }

    prev.addEventListener('click', function () {
      index--;
      update();
    });

    next.addEventListener('click', function () {
      index++;
      update();
    });

    viewport.addEventListener(
      'pointerdown',
      function (event) {
        dragging = true;
        startX = event.clientX;
      }
    );
    
    viewport.addEventListener(
      'pointerup',
      function (event) {
        if (!dragging) {
          return;
        }

        dragging = false;

        var distance = event.clientX - startX;

        if (Math.abs(distance) > 45) {
          index += distance < 0 ? 1 : -1;
          update();
        }
      }
    );

    viewport.addEventListener(
      'pointercancel',
      function () {
        dragging = false;
      }
    );

    var resizeTimer;

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(
          function () {
            update();
          },
          100
        );
      }
    );

    update();
  }

  function initAll() {
    document
      .querySelectorAll('.hs-bs')
      .forEach(initBestSellers);
  }

  initAll();

  document.addEventListener(
    'shopify:section:load',
    initAll
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBestSellers(root) {
    if (!root || root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    var track = root.querySelector('.hs-bs__track');
    var viewport = root.querySelector('.hs-bs__viewport');
    var prev = root.querySelector('.hs-bs__prev');
    var next = root.querySelector('.hs-bs__next');

    if (!track || !viewport || !prev || !next) {
      return;
    }

    var fallback = root.dataset.fallback === 'true';

    var cards = Array.prototype.slice.call(
      root.querySelectorAll('.hs-bs__card')
    );

    var index = 0;
    var startX = 0;
    var dragging = false;

    if (fallback && cards.length > 10) {
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));

        var temp = cards[i];

        cards[i] = cards[j];
        cards[j] = temp;
      }

      cards.forEach(function (card) {
        track.appendChild(card);
      });

      cards.slice(10).forEach(function (card) {
        card.remove();
      });

      cards = Array.prototype.slice.call(
        root.querySelectorAll('.hs-bs__card')
      );
    }

    function visibleCount() {
      if (window.innerWidth <= 760) {
        return 2;
      }

      if (window.innerWidth <= 1100) {
        return 3;
      }

      return 4;
    }

    function update() {
      if (!cards.length) {
        return;
      }

      var visible = visibleCount();

      var max = Math.max(
        0,
        cards.length - visible
      );

      index = Math.max(
        0,
        Math.min(index, max)
      );

      var width = cards[0].getBoundingClientRect().width;
      var gap =
        parseFloat(
          window.getComputedStyle(track).gap
        ) || 0;

      track.style.transform =
        'translate3d(-' +
        (index * (width + gap)) +
        'px, 0, 0)';

      prev.disabled = index <= 0;
      next.disabled = index >= max;
    }

    prev.addEventListener('click', function () {
      index--;
      update();
    });

    next.addEventListener('click', function () {
      index++;
      update();
    });

    viewport.addEventListener(
      'pointerdown',
      function (event) {
        dragging = true;
        startX = event.clientX;
      }
    );
    
    viewport.addEventListener(
      'pointerup',
      function (event) {
        if (!dragging) {
          return;
        }

        dragging = false;

        var distance = event.clientX - startX;

        if (Math.abs(distance) > 45) {
          index += distance < 0 ? 1 : -1;
          update();
        }
      }
    );

    viewport.addEventListener(
      'pointercancel',
      function () {
        dragging = false;
      }
    );

    var resizeTimer;

    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(
          function () {
            update();
          },
          100
        );
      }
    );

    update();
  }

  function initAll() {
    document
      .querySelectorAll('.hs-bs')
      .forEach(initBestSellers);
  }

  initAll();

  document.addEventListener(
    'shopify:section:load',
    initAll
  );
})();

  } catch(e) { console.error(e); }
})();
})();
